import { render, staticRenderFns } from "./Agencies.vue?vue&type=template&id=5c5680c8&scoped=true"
import script from "./Agencies.vue?vue&type=script&lang=js"
export * from "./Agencies.vue?vue&type=script&lang=js"
import style0 from "./Agencies.vue?vue&type=style&index=0&id=5c5680c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5680c8",
  null
  
)

export default component.exports